/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'actions-navigation-close-outline': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M10 1.25A8.696 8.696 0 001.25 10 8.696 8.696 0 0010 18.75 8.696 8.696 0 0018.75 10 8.696 8.696 0 0010 1.25zm0 16.25c-4.125 0-7.5-3.375-7.5-7.5S5.875 2.5 10 2.5s7.5 3.375 7.5 7.5-3.375 7.5-7.5 7.5zm3.375-3.125L10 11l-3.375 3.375-1-1L9 10 5.625 6.625l1-1L10 9l3.375-3.375 1 1L11 10l3.375 3.375-1 1z"/>'
  }
})
